const VALID_PHONE_SIZE = 11;

export function isValid(fields) {
    for (let i = 0; i < fields.length; i++) {
        const field = fields[i];
        
        if (!field.value) {
            return false;
        }
        
        if (field.type === 'tel' && field.value.replace(/\D/g, '').length !== VALID_PHONE_SIZE) {
            return false;
        }
    }

    return true;
}

export function phoneMask(field) {
    field.addEventListener('input', function(event) {
        let value = event.target.value.replace(/\D/g, '');
        let formattedValue = '';

        if (value.length > VALID_PHONE_SIZE) {
            value = value.substring(0, VALID_PHONE_SIZE);
        }
        
        if (value.length <= 2) {
            formattedValue = value;
        } else if (value.length <= 3) {
            formattedValue = `(${value.substring(0, 2)}) ${value.substring(2)}`;
        } else if (value.length <= 7) {
            formattedValue = `(${value.substring(0, 2)}) ${value.substring(2, 3)} ${value.substring(3)}`;
        } else {
            formattedValue = `(${value.substring(0, 2)}) ${value.substring(2, 3)} ${value.substring(3, 7)}-${value.substring(7)}`;
        }
        
        event.target.value = formattedValue;
    });
}